export const FILTER_BY_NO_BARCODE = 'Barcode';
export const FILTER_BY_NO_PROSOFT_ID = 'InternalID';